<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      left-text="返回"
      right-text
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="navbar"
    >
      <van-icon name="apps-o" size=".4rem" slot="right" />
    </van-nav-bar>
    <van-row class="table-header fixed">
      <van-col span="12">名称</van-col>
      <van-col span="6">价格</van-col>
      <van-col span="6">数量</van-col>
    </van-row>
    <div class="content-scroll-list-wrap table-header-navbar footernavbar" ref="scrollWrapper">
      <div class="nodata" v-if="!list.length">没有到任何数据!</div>
      <cube-scroll
        ref="contentScroll"
        :data="list"
        :options="options"
        @pulling-up="onPullingUp"
        @pulling-down="onPullingDown"
      >
        <van-checkbox-group v-model="selected">
          <van-row class="table-list-data" v-for="(item,index) in list">
            <van-col span="12">{{item.title}}</van-col>
            <van-col span="6">￥{{item.price}}</van-col>
            <van-col span="6">x{{item.num}}</van-col>
          </van-row>
        </van-checkbox-group>
      </cube-scroll>
    </div>
    <div class="footer-navbar">
      <div class="priceinfo">
        合计：
        <span class="totalprice">￥{{totalprice}}</span>
      </div>
      <van-field v-model="changprice" placeholder="请输入计算公式" />
      <van-button type="danger" class="op-jisuan" @click="onCalcuPrice">计算</van-button>
    </div>
  </div>
</template>

<script>
import { OrderModel } from "@models/common/order";
import { ERR_OK } from "@/common";
const orderModel = new OrderModel();

export default {
  data() {
    return {
      list: [],
      title: "订单详情",
      options: {
        pullDownRefresh: {
          threshold: 60,
          stopTime: 1000,
          txt: "更新成功"
        },
        pullUpLoad: {
          txt: {
            noMore: "没有了"
          }
        }
      },
      checkedAll: false,
      selected: [],
      totalpage: 1,
      page: 1,
      merchname: "",
      parentid: 0,
      changprice: "",
      totalprice: 0,
      ori_totalprice: 0,
    };
  },
  computed: {
   
  },
  methods: {
    onClickLeft() {
      this.$redirect(`/admin/order/childorder/${this.parentid}`);
    },
    onClickRight() {
      this.$redirect(`/admin/order/edit/${this.$route.params.id}`, {
        merchname: this.merchname
      });
    },
    onPullingUp() {
      if (this.page < this.totalpage) {
        setTimeout(() => {
          this.page++;
          this.getData();
        }, 1000);
      } else {
        this.$refs.contentScroll.forceUpdate();
      }
    },
    onPullingDown() {
      let params = {};
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.getData();
      }, 1000);
    },
    getData() {
      orderModel
        .getDetail({
          id: this.$route.params.id,
          page: this.page
        })
        .then(res => {
          if (ERR_OK == res.code) {
            this.totalpage = res.data.last_page;
            this.list = this.list.concat(res.data.data);
            this.title = `(${res.data.merchname})` + "订单详情";
            this.merchname = res.data.merchname;
            this.parentid = res.data.parentid;
            this.totalprice = this.$number_format(res.data.totalprice,2);
            this.ori_totalprice = this.$number_format(res.data.totalprice,2);
          }
        });
    },
    onCalcuPrice() {
      this.totalprice = this.$number_format(eval(`${this.ori_totalprice}${this.changprice}`),2)
    },
    onEvent() {}
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}

.navbar {
  color: #fff;
  background: #2196f3;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}

.content-scroll-list-wrap img {
  max-width: 100%;
}

>>>.table-header {
  top: 0.92rem;
}

>>>.content-scroll-list-wrap.table-header-navbar {
  top: 1.8rem;
  height: calc(100% - 1.72rem);
}

>>>.content-scroll-list-wrap.footernavbar {
  height: calc(100% - 0.92rem - 1.8rem);
}

.footer-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -5px 5px #eee; 
}

.priceinfo {
  padding-left: 0.4rem;
  width: 10rem;
}

.priceinfo .totalprice {
  color: red;
  font-weight: bold;
  font-size: 0.4rem;
}

.op-jisuan {
  height: 100%;
  border: 0;
  width: 5rem;
}
</style>
